import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayCircleOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 0L16 0 16 16 0 16z",
			transform: "translate(-1331 -984) translate(0 960) translate(1251 14) translate(64) translate(16 10)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#FFF",
			fillRule: "nonzero",
			d: "M6.4 11.6L11.2 8 6.4 4.4v7.2zM8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4c-3.528 0-6.4-2.872-6.4-6.4 0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4z",
			transform: "translate(-1331 -984) translate(0 960) translate(1251 14) translate(64) translate(16 10)"
		})] }) }) }) }) })
	})
});
export default SvgPlayCircleOutline;
